import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./i18n/profile-creation-side-intro.i18n.json'));

type Props = {};

class ProfileCreationSideIntro extends React.PureComponent<Props> {
  render() {
    return (
      <section className="profile-creation-side-intro">
        <img
          className="profile-creation-side-intro__image"
          src="/static/images/example-influencer-profile.png"
          alt={__t('profile_creation_side_intro.side_intro_heading')}
        />
        <div className="profile-creation-side-intro__heading">
          {__t('profile_creation_side_intro.side_intro_heading')}
        </div>
      </section>
    );
  }
}

export default ProfileCreationSideIntro;
